module.exports = __webpack_public_path__ + "img/DrDorr.a3fcd20c.png";